import { useState, useEffect, useDebugValue } from "react";
import { useNavigate } from "react-router-dom";
import { get } from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const useGetMultiple = (apiEndpoints, saveData) => {
  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const getData = async () => {
    try {
      const requests = apiEndpoints.map((url) => get(url));
      const responses = await Promise.all(requests);
      const responseData = responses.map((res) => res.data);

      // SAVE PAYLOAD DATA IN LOCAL STORE
      if (saveData === "payload") {
        localStorage.setItem("uuid", responseData[0].uuid);
        localStorage.setItem("userId", responseData[1].userData.id);
        localStorage.setItem("userName", responseData[1].userData.fullName);
        localStorage.setItem("perms", responseData[1].claims.permissions);
        localStorage.setItem("roles", responseData[1].claims.role);
        localStorage.setItem(
          "access_token_time",
          responseData[1].claims.access_token_issued_at_utc_tz,
        );
        const picList = responseData[1]?.userData?.profilePicUrlList;

        const profilePic =
          Array.isArray(picList) && picList.length > 0 ? picList[0] : "";
        localStorage.setItem("profilePic", profilePic);
      }
      setData(responseData); // array of response data
    } catch (error) {
      if (error.response?.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setError(error.response?.data?.message || error.message);
      }
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    getData(apiEndpoints);
  }, []);

  useDebugValue("Api data in multiple");


  return {
    data, // Array of response data
    isLoaded,
    error,
    getData,
    setIsLoaded,
    setError,
    setData,
  };
};

export default useGetMultiple;
